import { useState } from 'react';
import { isNil } from 'lodash';
import { useTransformEvent } from '@ion/api';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import DEFAULT_PLAYBOOK from 'app/shared/translation/pipelines/DEFAULT_PLAYBOOK';
import resolvePipelineConfiguration from 'app/shared/translation/pipelines/resolvePipelineConfiguration';

export default function usePipelineOutput() {
  const { pipeline } = usePipelinePageContext();
  const [inputEvent, setInputEvent] = useState(null);

  const [
    transformEvent,
    { loading, error, outputEvent: transformOutputEvent, errors /* reset: resetTransformEvent */ },
  ] = useTransformEvent();

  const { cluster } = pipeline;
  const { transform, filter } = resolvePipelineConfiguration({
    deployedPipeline: pipeline.deployedPipeline,
    configuredPipeline: pipeline,
  });
  const { id: clusterId } = cluster;

  const hasTransform = !isNil(transform);
  const hasFilter = !isNil(filter);
  const shouldTransform = hasTransform || hasFilter;

  const executePipelineTransform = ({ parsedInputEvent }) => {
    setInputEvent(parsedInputEvent);
    if (shouldTransform) {
      transformEvent({
        // Tech Debt - See comment in DEFAULT_PLAYBOOK
        playbook: transform?.data.playbook ?? DEFAULT_PLAYBOOK,
        // inputEvent and originalEvent are the same here because this is the first
        // step of the chain — there is no prior transform output yet, so the input
        // to the playbook IS the original client event. Downstream steps pass the
        // upstream transform output as inputEvent and keep originalEvent constant.
        inputEvent: parsedInputEvent,
        originalEvent: parsedInputEvent,
        pipelineFilter: filter,
        clusterId,
      });
    }
  };

  // If there is no transform, the outputEvent is just the inputEvent
  const outputEvent = shouldTransform ? transformOutputEvent : inputEvent;

  const reset = () => {
    setInputEvent(null);
    //resetTransformEvent();
  };

  return [executePipelineTransform, { loading, error, outputEvent, errors, reset }];
}
